import PostCard from './PostCard';

export default PostCard;
export * as PostCardStyles from './PostCard.styles';
export * as PostCardTypes from './PostCard.types';
